import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

import FacebookAdAuthButton from '../components/buttons/FacebookAdAuth';
import AdAccountModal from '../components/adAccounts/AdAccountModal';
import AlertMessage from '../components/pop/AlertMessage';

import {
  LinkCustom,
  FullImage
} from '../components/CustomComp'

import {
  styledTextEllipsis,
  BoxFlexBetweenCenter,
  BoxFlexColumnCenterCenter
} from '../components/customComponent/box';

import { ButtonSyetemMain } from '../components/customComponent/button'
import { SearchInput } from '../components/customComponent/form';

import {
  AddLinkOutlinedIcon,
  SearchIcon,
  InsertLinkOutlinedIcon,
  CheckBoxIcon,
  CloseOutlinedIcon
} from '../constants/images';

import {
  getComparator,
  stableSort
} from '../utils/utils';

import img_filterNoData from '../assets/images/img_filterNoData.svg';
import img_noData from '../assets/images/img_noData.svg';

import { styled } from '@mui/material/styles';
import theme from '../theme';

import { apiList, getCancelData } from '../api/callAPI';
import useUser from '../hook/useUser';
import useCancel from '../hook/useCancel';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';
import * as adAccountConstants from '../components/adAccounts/constants';
import { CheckBox } from '@mui/icons-material';

const headCells = [{
  id: 'adAccountId',
  orderName: 'adAccountId',
  displayName: "account.table.accountId",
  align: 'left',
  width: 'auto',
  minWidth: '240px'
}, {
  id: 'adAccountName',
  orderName: 'adAccountName',
  displayName: "account.table.accountName",
  align: 'left',
  width: 'auto',
  minWidth: 'auto'
}
];

const mediaMainColor = theme.palette.system.main;

const RenderTdContent = ({ id, row }) => {

  return (
    <Typography>{row[id]}</Typography>
  );
}

const CreateAdAccounts = (props) => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  // const { currentAccount, setCurrentAccount } = useAccount();
  const { cancelData, setCancelData } = useCancel();

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(headCells[0].orderName);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [tableData, setTableData] = useState([]);
  const [tableDataLength, setTableDataLength] = useState(0);
  const [selected, setSelected] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [currentCheckAdAccount, setCurrentCheckAdAccount] = useState(null);
  const { currentAccount, setCurrentAccount } = useState(false);

  const [searchKeyword, setSearchKeyword] = useState(null);

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [modalType, setModalType] = useState('chooseMedia');
  const [mediaData, setMediaData] = useState({
    media: '',
    token: '',
    userId: ''
  });

  const [alertContent, setAlertContent] = useState({
    open: false,
    message: ''
  });
  const [noAdAccountMsg, setNoAdAccountMsg] = useState({ media: 'Facebook', msg: '' });
  const [googleAccountData, setGoogleAccountData] = useState({});

  const handleLoginMedia = (media) => {
    setModalType(adAccountConstants.LOGIN_MEDIA);
    setMediaData({ media: media });
  }

  const chooseMedia = (token) => {
    setGoogleAccountData(token);
    setModalType(adAccountConstants.CHOOSE_MEDIA);
  }

  const fetchData = (data) => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    setIsLoadingData(true);

    apiList.apiGetFacebookAdAccounts(data.query).then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

      setIsLoadingData(false);
      // console.log("呼叫FB帳號清單_Token", data.query)

      if (res.status === 200) {
        if (!res.data.result.length) {
          setNoAdAccountMsg({
            media: data.media,
            msg: 'addAccount.notManageAnyAccounts',
          });
        } else {
          setNoAdAccountMsg({});
        }
        setTableData(res.data.result);
        setTableDataLength(res.data.result.length);
        // console.log("FB帳號清單", res.data.result)

      } else if (res.status === 401) {
        const message = intl.formatMessage({
          id: alertConstants.ERROR_FB_CERTIFICATE,
          defaultMessage: '登入憑證已過期，請將Facebook登出後，再重新進行授權。'
        });
        alert(message);
        history.push(urlConstants.PAGE_AD_ACCOUNTS);

      } else {
        setFilterData([]);
        // const message = intl.formatMessage({
        //   id: alertConstants.ERROR_FB_CERTIFICATE,
        //   defaultMessage: '系統連線錯誤，請聯繫系統管理員處理。'
        // });
        alert(alertConstants.ERROR_SYSTEMCONNECT);
      }
    })

  }

  const fetchGoogleData = (data) => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    setIsLoadingData(true);

    apiList.apiGetGoogleAdAccounts(data.query).then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
      setIsLoadingData(false);

      if (res.status === 200) {
        if (!res.data.result.length) {
          setNoAdAccountMsg({
            media: data.media,
            msg: 'addAccount.notManageAnyAccounts',
          });
        } else {
          setNoAdAccountMsg({});
        }
        setTableData(res.data.result);
        setTableDataLength(res.data.result.length);
        // console.log("google帳號清單res", res.data.result)

      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        setFilterData([]);
        alert(alertConstants.ERROR_SYSTEMCONNECT);
      }
    })

  }

  const fetchLineData = (data) => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    setIsLoadingData(true);

    // console.log('fetchLineData_data', data)

    apiList.apiGetLineAdAccounts(data).then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
      setIsLoadingData(false);

      if (res.status === 200) {
        // console.log("line帳號清單res", res.data.result)
        setTableData(res.data.result);
        setTableDataLength(res.data.result.length);
      } else if (res.status === 201) {
        setNoAdAccountMsg({
          media: 'LINE',
          msg: 'addAccount.noAccountPermissions',
        });
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        setFilterData([]);
        alert(alertConstants.ERROR_SYSTEMCONNECT);
      }
    })
  }

  const fetchTaboolaData = (data) => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    setIsLoadingData(true);

    // console.log('fetchTaboola_data', data)

    apiList.apiGetTaboolaAdAccounts(data).then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
      setIsLoadingData(false);

      if (res.status === 200) {
        // console.log("Taboola帳號清單res", res.data.result)
        setTableData(res.data.result);
        setTableDataLength(res.data.result.length);
      } else if (res.status === 201) {
        setNoAdAccountMsg({
          media: 'Taboola',
          msg: 'addAccount.noAccountPermissions',
        });
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        setFilterData([]);
        alert(alertConstants.ERROR_SYSTEMCONNECT);
      }
    })
  }

  useEffect(() => {
    setFilterData(tableData)
  }, [tableData])

  useEffect(() => {
    if (searchKeyword === '' || !searchKeyword) {
      setFilterData(tableData);

    } else {
      setIsLoadingData(true);

      let timer = setTimeout(() => {
        const keyword = searchKeyword.replace(/-/g, "").trim();
        const filterTableData = tableData.filter((el) => el.adAccountId === keyword || el.adAccountName.includes(keyword));
        setFilterData(filterTableData);
        setIsLoadingData(false);
      }, 500)

      return () => {
        clearTimeout(timer);
        setIsLoadingData(false);
      };
    }
  }, [searchKeyword])

  useEffect(() => {
    if (mediaData.media === '') return;

    let timer = setTimeout(() => {
      let query;

      if (mediaData.media === basicConstants.FACEBOOK) {
        if (searchKeyword === '' || !searchKeyword) {
          query = {
            accessToken: mediaData.token,
            userId: mediaData.userId
          }
        } else {
          query = {
            accessToken: mediaData.token,
            userId: mediaData.userId,
            adAccountId: searchKeyword.trim()
          }
        };
        fetchData({
          media: mediaData.media,
          query
        })
      }
    }, 500)

    return () => clearTimeout(timer);
  }, [searchKeyword])

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    // setPage(0);
    // setIsLoadingData(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // setIsLoadingData(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // setIsLoadingData(true);
  };

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
    setPage(0);
  }

  const handelCancelSearch = () => {
    setSearchKeyword('');
  }

  const handleSubmit = (data) => {
    switch (modalType) {
      case adAccountConstants.LOGIN_MEDIA:
        setMediaData({
          media: data.media,
          token: data.query.accessToken,
          userId: data.query.userId
        });
        if (data.media === basicConstants.FACEBOOK) {
          fetchData(data);

        } else if (data.media === basicConstants.GOOGLE) {
          fetchGoogleData(data);

        } else if (data.media === basicConstants.LINE) {
          fetchLineData({ email: data.query.accessToken });

        } else if (data.media === basicConstants.TABOOLA) {
          fetchTaboolaData({ email: data.query.accessToken });
        }
        setModalType('');
        break;

      case adAccountConstants.LINK_AD_ACCOUNT:
        let query = {
          accessToken: mediaData.token,
          userId: mediaData.userId,
          adAccountIds: data
        };
        // console.log('LINK_AD_ACCOUNT_FACEBOOK', query)
        setModalType(adAccountConstants.LINK_AD_ACCOUNT_ANIMATION);

        apiList.apiBindFacebookAdAccounts(query).then(res => {
          if (res.status === 200) {
            setAlertContent({
              open: true,
              message: '授權成功！'
            });

            setTimeout(() => {
              history.push(urlConstants.PAGE_AD_ACCOUNTS);
            }, 2000)
          } else if (res.status === 401) {
            setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
            setUserData(false);
            history.push(urlConstants.PAGE_LOGIN);
          } else {
            setAlertContent({
              open: true,
              message: '授權失敗，請重新嘗試，或洽管理員處理。'
            });
          }

          setModalType('');
        })

        break;

      case adAccountConstants.LINK_AD_ACCOUNT_GOOGLE:
        const accountId = currentCheckAdAccount.adAccounts.map((el) => el.adAccountId).toString();
        let googleQuery = {
          email: mediaData.token,
          adAccountIds: accountId
        };
        // console.log('LINK_AD_ACCOUNT_GOOGLE', query)
        setModalType(adAccountConstants.LINK_AD_ACCOUNT_ANIMATION);

        apiList.apiBindGoogleAdAccounts(googleQuery).then(res => {
          if (res.status === 200) {
            setAlertContent({
              open: true,
              message: '授權成功！'
            });
            setTimeout(() => {
              history.push(urlConstants.PAGE_AD_ACCOUNTS);
            }, 2000)
          } else if (res.status === 401) {
            setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
            setUserData(false);
            history.push(urlConstants.PAGE_LOGIN);
          } else {
            setAlertContent({
              open: true,
              message: '授權失敗，請重新嘗試，或洽管理員處理。'
            });
          }

          setModalType('');
        })

        break;

      case adAccountConstants.LINK_AD_ACCOUNT_LINE:
        const lineQuery = currentCheckAdAccount.adAccounts.map((el) => {
          return {
            accountId: el.adAccountId,
            accountName: el.adAccountName
          }
        })

        // console.log('LINK_AD_ACCOUNT_LINE', lineQuery);

        setModalType(adAccountConstants.LINK_AD_ACCOUNT_ANIMATION);

        apiList.apiBindLineAdAccounts(lineQuery).then(res => {
          if (res.status === 200) {
            setAlertContent({
              open: true,
              message: '授權成功！'
            });
            setTimeout(() => {
              history.push(urlConstants.PAGE_AD_ACCOUNTS);
            }, 2000)
          } else if (res.status === 401) {
            setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
            setUserData(false);
            history.push(urlConstants.PAGE_LOGIN);
          } else {
            setAlertContent({
              open: true,
              message: '授權失敗，請重新嘗試，或洽管理員處理。'
            });
          }

          setModalType('');
        })

        break;

      case adAccountConstants.LINK_AD_ACCOUNT_TABOOLA:
        const taboolaQuery = currentCheckAdAccount.adAccounts.map((el) => {
          return {
            accountId: el.adAccountId,
            accountName: el.adAccountName
          }
        })

        // console.log('LINK_AD_ACCOUNT_TABOOLA', taboolaQuery);

        setModalType(adAccountConstants.LINK_AD_ACCOUNT_ANIMATION);

        apiList.apiBindTaboolaAdAccounts(taboolaQuery).then(res => {
          if (res.status === 200) {
            setAlertContent({
              open: true,
              message: '授權成功！'
            });
            setTimeout(() => {
              history.push(urlConstants.PAGE_AD_ACCOUNTS);
            }, 2000)
          } else if (res.status === 401) {
            setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
            setUserData(false);
            history.push(urlConstants.PAGE_LOGIN);
          } else {
            setAlertContent({
              open: true,
              message: '授權失敗，請重新嘗試，或洽管理員處理。'
            });
          }

          setModalType('');
        })

        break;

      default:
        return;
    }
  }

  const handleClickSelectAll = (e) => {
    const { checked } = e.target;

    if (checked) {
      const selectedAll = tableData.map(el => ({ adAccountId: el.adAccountId, adAccountName: el.adAccountName }));

      setSelected(selectedAll)
      return;
    }

    setSelected([]);

  }

  const handleClickCheckbox = (row) => {

    setSelected(prev => {
      return _.xorBy(selected, [{ adAccountId: row.adAccountId, adAccountName: row.adAccountName }], 'adAccountId')
    });
  }

  return (
    <>
      <Typography variant="h2"><FormattedMessage id="addAccount.title" /></Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginTop: '-50px'
        }}
      >
        <SearchInput
          id="search"
          placeholder={intl.formatMessage({ id: "addAccount.search.accounts" })}
          startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
          endAdornment={
            searchKeyword && (
              <InputAdornment position="end">
                <CloseOutlinedIcon onClick={handelCancelSearch} />
              </InputAdornment>
            )}
          sx={{
            width: {
              xs: `calc(100% - 160px - 4px)`,
              sm: '50%',
              md: '40%'
            },
            cursor: 'pointer'
          }}
          value={searchKeyword}
          // disabled={isLoadingData}
          onChange={handleSearchInput}
        />
      </Box>

      <TableContainer
        sx={{
          position: 'relative',
          height: `${basicConstants.TABLE_ROW_HEIGHT_2 * basicConstants.TABLE_BASIC_ROW_NUM}px`,
          minHeight: `${basicConstants.TABLE_ROW_HEIGHT_2 * basicConstants.TABLE_BASIC_ROW_NUM}px`,
          maxHeight: `${basicConstants.TABLE_ROW_HEIGHT_2 * basicConstants.TABLE_BASIC_ROW_NUM}px`,
          marginTop: 4,
          borderRadius: '4px',
          border: `1px solid ${theme.palette.grey.w300}`,
          borderColor: (filterData.length > 0 || searchKeyword || isLoadingData) ? theme.palette.grey.w300 : 'transparent'
        }}
      >
        {
          filterData.length > 0 &&
          <BoxFlexBetweenCenter
            sx={{
              padding: `${'8px'} ${'32px'}`
            }}
          >
            <Typography
              sx={{
                marginTop: '8px',
                marginBottom: '8px'
              }}
            >
              <FormattedMessage
                id="addAccount.selectedAccount"
                values={{
                  number: <span style={{ color: mediaMainColor }}>{selected.length}</span>,
                }}
              />
            </Typography>
            {
              selected.length > 0 && mediaData.media === basicConstants.FACEBOOK &&
              <ButtonSyetemMain
                variant="contained"
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{
                  width: '180px'
                }}
                onClick={() => {
                  setCurrentCheckAdAccount({
                    media: mediaData.media,
                    adAccounts: selected
                  })
                  setModalType('linkAdAccount');
                }}
              >
                <FormattedMessage id="addAccount.button.authorizeSelected" />
              </ButtonSyetemMain>
            }
            {
              selected.length > 0 && mediaData.media === basicConstants.GOOGLE &&
              <ButtonSyetemMain
                variant="contained"
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{
                  width: '180px'
                }}
                onClick={() => {
                  setCurrentCheckAdAccount({
                    media: mediaData.media,
                    adAccounts: selected
                  })
                  setModalType('linkAdAccountGoogle');
                }}
              >
                <FormattedMessage id="addAccount.button.authorizeSelected" />
              </ButtonSyetemMain>
            }
            {
              selected.length > 0 && mediaData.media === basicConstants.LINE &&
              <ButtonSyetemMain
                variant="contained"
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{
                  width: '180px'
                }}
                onClick={() => {
                  setCurrentCheckAdAccount({
                    media: mediaData.media,
                    adAccounts: selected
                  })
                  setModalType('linkAdAccountLine');
                }}
              >
                <FormattedMessage id="addAccount.button.authorizeSelected" />
              </ButtonSyetemMain>
            }
            {
              selected.length > 0 && mediaData.media === basicConstants.TABOOLA &&
              <ButtonSyetemMain
                variant="contained"
                startIcon={<InsertLinkOutlinedIcon />}
                sx={{
                  width: '180px'
                }}
                onClick={() => {
                  setCurrentCheckAdAccount({
                    media: mediaData.media,
                    adAccounts: selected
                  })
                  setModalType(adAccountConstants.LINK_AD_ACCOUNT_TABOOLA);
                }}
              >
                <FormattedMessage id="addAccount.button.authorizeSelected" />
              </ButtonSyetemMain>
            }
          </BoxFlexBetweenCenter>
        }
        {
          filterData.length > 0 &&
          <>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    padding="checkbox"
                    align="center"
                    size="small"
                    sx={{
                      left: 0,
                      minWidth: '64px',
                      backgroundColor: theme.palette.grey.w300
                    }}
                  >
                    <Checkbox
                      color="primary"
                      indeterminate={selected.length > 0 && selected.length < tableData.length}
                      checked={tableData.length > 0 && selected.length === tableData.length}
                      onChange={handleClickSelectAll}
                      style={{
                        color: 'white'
                      }}
                    />
                  </TableCell>
                  {
                    headCells.map((headCell, index) => {
                      return (
                        <TableCell
                          key={headCell.id}
                          align={headCell.align}
                          sortDirection={orderBy === headCell.orderName ? order : false}
                          size="small"
                          sx={{
                            width: headCell.width,
                            minWidth: headCell.minWidth,
                            padding: '8px 16px',
                            backgroundColor: theme.palette.grey.w300,
                            color: '#fff',
                          }}
                        >
                          <TableSortLabel
                            active={orderBy === headCell.orderName}
                            direction={orderBy === headCell.orderName ? order : 'asc'}
                            onClick={createSortHandler(headCell.orderName)}
                            sx={{
                              '&.Mui-active, &.Mui-active .MuiTableSortLabel-icon': {
                                color: '#fff'
                              },

                              '&:hover': {
                                color: '#fff'
                              }
                            }}
                          >
                            <FormattedMessage id={headCell.displayName} />
                          </TableSortLabel>
                        </TableCell>
                      )
                    })
                  }
                  <TableCell
                    key="link"
                    align="center"
                    size="small"
                    sx={{
                      width: '60px',
                      minWidth: '60px',
                      padding: '8px 16px',
                      backgroundColor: theme.palette.grey.w300,
                      color: '#fff',
                    }}
                  >
                    <FormattedMessage id="addAccount.authorize" />
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {
                  stableSort(filterData, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isSelected = selected.findIndex((el, index) => el.adAccountId === row.adAccountId) > -1;

                      return (
                        <TableRow
                          key={`${row.adAccountId}_${index}`}
                          hover
                          sx={{
                            backgroundColor: row.linked ? theme.palette.grey.w0 : null
                          }}
                        >
                          {
                            row.linked &&
                            <TableCell
                              padding="checkbox"
                              align="center"
                            >
                              <Checkbox
                                checked={true}
                                disabled={true}
                                sx={{
                                  marginTop: '6px',
                                  color: theme.palette.grey.w300
                                }}
                              />
                            </TableCell>
                          }

                          {
                            !row.linked &&
                            <TableCell
                              padding="checkbox"
                              align="center"
                              onClick={(e) => handleClickCheckbox(row, index)}
                            >
                              <Checkbox
                                color="primary"
                                checked={isSelected}
                              />
                            </TableCell>
                          }

                          {
                            headCells.map((cell, index) => {

                              return (
                                <TableCell
                                  key={`${cell.id}${index}`}
                                  align={cell.align}
                                  size="small"
                                  sx={{
                                    width: cell.minWidth,
                                    padding: '12px 16px',
                                    color: row.linked ? theme.palette.grey.w500 : 'inherit'
                                  }}
                                  onClick={(e) => {
                                    if (!row.linked) handleClickCheckbox(row, index);
                                  }}
                                >
                                  <RenderTdContent
                                    id={cell.id}
                                    row={row}
                                  />
                                </TableCell>
                              )
                            })
                          }

                          <TableCell size="small" align="center">
                            {
                              mediaData.media === basicConstants.FACEBOOK && !row.linked &&
                              <Tooltip title={<FormattedMessage id="account.button.AuthorizedAccounts" />}>
                                <InsertLinkOutlinedIcon
                                  variant="dark"
                                  sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                      color: mediaMainColor
                                    }

                                  }}
                                  onClick={() => {
                                    setCurrentCheckAdAccount({
                                      media: mediaData.media,
                                      adAccounts: [row]
                                    });
                                    setModalType(adAccountConstants.LINK_AD_ACCOUNT);
                                  }}
                                />
                              </Tooltip>
                            }
                            {
                              mediaData.media === basicConstants.GOOGLE && !row.linked &&
                              <Tooltip title={<FormattedMessage id="account.button.AuthorizedAccounts" />}>
                                <InsertLinkOutlinedIcon
                                  variant="dark"
                                  sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                      color: theme.palette.primary.main
                                    }

                                  }}
                                  onClick={() => {
                                    setCurrentCheckAdAccount({
                                      media: mediaData.media,
                                      adAccounts: [row]
                                    });
                                    setModalType(adAccountConstants.LINK_AD_ACCOUNT_GOOGLE);
                                  }}
                                />
                              </Tooltip>
                            }
                            {
                              mediaData.media === basicConstants.LINE && !row.linked &&
                              <Tooltip title={<FormattedMessage id="account.button.AuthorizedAccounts" />}>
                                <InsertLinkOutlinedIcon
                                  variant="dark"
                                  sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                      color: mediaMainColor
                                    }

                                  }}
                                  onClick={() => {
                                    setCurrentCheckAdAccount({
                                      media: mediaData.media,
                                      adAccounts: [row]
                                    });
                                    setModalType(adAccountConstants.LINK_AD_ACCOUNT_LINE);
                                  }}
                                />
                              </Tooltip>
                            }
                            {
                              mediaData.media === basicConstants.TABOOLA && !row.linked &&
                              <Tooltip title={<FormattedMessage id="account.button.AuthorizedAccounts" />}>
                                <InsertLinkOutlinedIcon
                                  variant="dark"
                                  sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                      color: mediaMainColor
                                    }

                                  }}
                                  onClick={() => {
                                    setCurrentCheckAdAccount({
                                      media: mediaData.media,
                                      adAccounts: [row]
                                    });
                                    setModalType(adAccountConstants.LINK_AD_ACCOUNT_TABOOLA);
                                  }}
                                />
                              </Tooltip>
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })
                }
              </TableBody>

            </Table>
          </>
        }

        <Backdrop
          sx={{
            position: 'absolute',
            zIndex: 500,
            backgroundColor: 'transparent',
            color: theme.palette.grey.w500
          }}
          open={isLoadingData}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {
          filterData.length === 0 && searchKeyword &&
          <BoxFlexColumnCenterCenter sx={{ height: '100%' }} >
            <FullImage
              src={img_filterNoData}
              alt={intl.formatMessage({ id: "common.modal.noData", defaultMessage: "沒有符合條件的資料" })}
            />
            <Typography align="center" mt={4}>
              <FormattedMessage
                id="account.search.noResultsFound"
                values={{
                  keyword: <span style={{ color: theme.palette.system.main }}>{searchKeyword}</span>,
                  br: <br />,
                }}
              />
            </Typography>
          </BoxFlexColumnCenterCenter>
        }
        {
          filterData.length === 0 && !searchKeyword && !isLoadingData &&
          <BoxFlexColumnCenterCenter
            sx={{
              height: '100%'
            }}
          >
            <FullImage
              src={img_noData}
              alt={intl.formatMessage({ id: "addAccount.image.noMediaSelected", defaultMessage: "未選擇任何廣告媒體" })}
            />
            {
              noAdAccountMsg && noAdAccountMsg?.msg &&
              <Typography sx={{ mt: 3, }}>
                <FormattedMessage id={noAdAccountMsg.msg} values={{ media: noAdAccountMsg.media }} />
              </Typography>
            }
          </BoxFlexColumnCenterCenter>
        }
      </TableContainer>

      {
        filterData.length > 0 &&
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 25, 50, 100]}
          count={filterData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
        />
      }

      <AdAccountModal
        modalType={modalType}
        modalData={currentCheckAdAccount}
        mediaData={mediaData}
        handleCloseModal={() => setModalType('')}
        handleSubmit={handleSubmit}
        chooseMedia={chooseMedia}
        googleAccountData={googleAccountData}
        handleLoginMedia={handleLoginMedia}
      />

      <AlertMessage
        type="noAction"
        isOpen={alertContent.open}
        message={alertContent.message}
        handleClose={() => {
          setAlertContent({
            open: false,
            message: ''
          });
        }}
      />
    </>
  );
}

export default CreateAdAccounts;